import { Component, Mixins, Prop, VModel } from 'vue-property-decorator';
import PaymentRequirementsConfirmDialog from '@/feature/PaymentRequirements/components/Incoming/PaymentRequirementsConfirmDialog.vue';
import PaymentRequirementsSuccessDialog from '@/feature/PaymentRequirements/components/Incoming/PaymentRequirementsSuccessDialog.vue';
import Redirect from '@/mixins/redirect/redirect';
import PaymentRequirementsIncomingSign from '../Sign/PaymentRequirementsIncomingSign';
import { DigitalSignCommonData } from '@/mixins/crk/interface';
import { PaymentRequirementsIncomingStore } from '../../../store/incoming';
import { PaymentRequirementsIncomingGetter } from '../../../store/incoming/constants';

@Component({
	components: {
		PaymentRequirementsConfirmDialog,
		PaymentRequirementsSuccessDialog,
	}
})
export default class PaymentRequirementsIncomingHandler extends Mixins(
	Redirect,
	PaymentRequirementsIncomingSign
) {

	@PaymentRequirementsIncomingStore.Getter(
		PaymentRequirementsIncomingGetter.unprocessedCount
	)
	readonly paymentRequirementsIncomingCount!: number

	@VModel({ type: Boolean })
	paymentRequirementsConfirmDialog!: boolean

	@Prop(Function)
	saveOperationToDraft!: () => Promise<any>

	paymentRequirementsSuccessDialog: boolean = false

	paymentRequirementsTotalCount: number = 0

	paymentRequirementsProcessedCount: number = 0

	excludedOperationProcessRouteNames: string[] = [
		'paymentRequirementsIncoming',
		'Home',
	]

	onConfirmPaymentRequirementsOffer() {
		this.paymentRequirementsConfirmDialog = false;

		this.signPaymentRequirementsIncoming();
	}

	async onConfirmPaymentRequirementsSuccess() {
		if (this.isOperationProcess && this.saveOperationToDraft) {
			const operationSaved = await this.saveOperationToDraft();

			if (!operationSaved) return;
		}

		this.paymentRequirementsSuccessDialog = false;

		this.redirectTo('CardIndex');
	}

	async onSignPaymentRequirements(signData: DigitalSignCommonData) {
		const signResult = await this.signUnprocessedPaymentRequirements(signData);

		if (!signResult) return;

		this.paymentRequirementsTotalCount = signResult?.total
			|| this.paymentRequirementsIncomingCount
			|| 0;

		this.paymentRequirementsProcessedCount = signResult?.successfullyProcessed || 0;
		this.digitalSignDialog = false;
		this.paymentRequirementsSuccessDialog = true;
	}

	get isOperationProcess(): boolean {
		return !this.excludedOperationProcessRouteNames.includes(
			this.$route.name!
		);
	}

}